module.exports = __webpack_public_path__ + "assets/img/0_01en.31d7ee21.jpg";